@if (showHeader()) {
<app-header></app-header>
}
<main>
  <router-outlet></router-outlet>
</main>
<!-- Spec 029: aceite obrigatório de Termos e Privacidade; fica fora do if do
     header para valer em toda tela, inclusive no onboarding. -->
<app-legal-consent-modal />
